import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CreateClientSecret, DeleteClientSecret, useClient } from "./ClientStore";
import { Button, Table } from "../components/Modal";

import { useParams } from "react-router-dom";
import ApiKeyManager from "../apiKeys/ApiKeyManager";

const ClientSecrets = ({ user, policies }) => {
    const params = useParams();
    const [client, refresh] = useClient(params.id);

    const [secret, setSecret] = React.useState("");

    let hasPermission = (permission) => {
        if (user && policies) {
            if (user.claims.filter((c) => c.type == "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" && c.value == "Admin").length > 0) {
                return true;
            } else {
                return policies.filter((policy) => policy.permission == permission).length > 0;
            }
        }
        return false;
    };

    let createSecret = () => {
        CreateClientSecret(client.id).then((response) => {
            refresh();
            setSecret(response.data.secret);
        });
    };

    let deleteSecret = (secretId) => {
        DeleteClientSecret(client.id, secretId).then((response) => {
            refresh();
        });
    };

    let copySecret = () => {
        // @ts-ignore
        navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
            if (result.state == "granted" || result.state == "prompt") {
                navigator.clipboard.writeText(secret).then(
                    function () {
                        /* clipboard successfully set */
                    },
                    function () {
                        /* clipboard write failed */
                    }
                );
            }
        });
    };

    return (
        <>
            {hasPermission("manageClients") && client.id && <ApiKeyManager scope="client" subjectId={client.id} />}
            {hasPermission("manageClients") && client.id && (
                <Table>
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Secret</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {client.secrets.map((secret, i) => (
                            <tr key={"s" + i} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className="text-sm font-mono text-gray-900">{secret.value.substring(0, 20)}...</span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className="text-sm text-gray-500">{secret.created}</span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <Button variant="outline-danger" size="sm" onClick={() => deleteSecret(secret.id)}>
                                        <FontAwesomeIcon icon={["fad", "trash"]}></FontAwesomeIcon>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                        {secret && (
                            <tr className="bg-yellow-50 border-yellow-200">
                                <td className="px-6 py-4">
                                    <div className="text-sm text-red-600 font-medium">Copy this value before closing or navigating away from this page</div>
                                </td>
                                <td className="px-6 py-4">
                                    <span className="text-sm font-mono text-gray-900 break-all">{secret}</span>
                                </td>
                                <td className="px-6 py-4 text-right">
                                    <Button variant="outline-secondary" size="sm" onClick={copySecret}>
                                        <FontAwesomeIcon icon={["fad", "copy"]}></FontAwesomeIcon>
                                    </Button>
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td colSpan={3} className="px-6 py-4">
                                <button 
                                    className="text-blue-600 hover:text-blue-800 underline"
                                    onClick={createSecret}
                                >
                                    Add new secret
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            )}
        </>
    );
};

export default ClientSecrets;
